module.exports = __webpack_public_path__ + "img/4c54e8d.jpg";